export default {
  /** 接口api服务注册名称 **/
  dir: {
    helpFile:"help/",
    helpCoverFile:"help/cover/",
    courseware: "courseware/", // 课件目录
    enterpriseFile: 'enterpriseFile/', //企业文件目录（一企一档）
    teacherImage: "images/teacher",  // teacher images dir
    mallCoursewareImage: "image/mall-courseware/",  //商城课程图片
    mallBannerImage: "image/mall-banner/", //商城轮播图存放地址
    faceImage: 'face-image/', // 认证照破存储地址
    userCert: 'user-cert/' // 用户图片存放
  }
}



// WEBPACK FOOTER //
// ./src/components/common/oss/ossConstant.js